import { z } from "zod";

export const redirectSchema = z
	.object({
		from: z.string().optional(),
		redirect: z.string().optional(),
	})
	.optional();
